import styled from 'styled-components';
import { maxWidth, lineHeight, textAlign, alignSelf, fontSize, space } from 'styled-system';
export default styled.p.withConfig({
  displayName: "copy",
  componentId: "sc-12k0jfm-0"
})(["color:#6d747b;font-size:13px;line-height:23.25px;margin-bottom:12px;", " ", " ", " ", " ", " ", " b{font-weight:bolder;}"], maxWidth, lineHeight, textAlign, alignSelf, fontSize, space);